{
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.benefits.default-benefit.non-final": [
    {
      "children": [
        {
          "type": 0,
          "value": "Default benefit"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ": This is a placeholder for the default benefit"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.admin-center.description.non-final": [
    {
      "type": 1,
      "value": "requesterFullName"
    },
    {
      "type": 0,
      "value": " has requested to try the 'Admin Center' feature on the Confluence Premium plan. This will make it easy to configure your team's Confluence."
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.admin-center.no-name.description.non-final": [
    {
      "type": 0,
      "value": "Someone on your team has requested to try the 'Admin Center' feature on the Confluence Premium plan. This will make it easy to configure your team's Confluence."
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.admin-center.no-name.subject.non-final": [
    {
      "type": 0,
      "value": "Approval required: Someone in your team wants to try 'Admin Center'"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.admin-center.no-name.title.non-final": [
    {
      "type": 0,
      "value": "Help your team do more and worry less"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.admin-center.subject.non-final": [
    {
      "type": 0,
      "value": "Approval required: "
    },
    {
      "type": 1,
      "value": "requesterFullName"
    },
    {
      "type": 0,
      "value": " wants to try 'Admin Center'"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.admin-center.title.non-final": [
    {
      "type": 0,
      "value": "Help "
    },
    {
      "type": 1,
      "value": "requesterFullName"
    },
    {
      "type": 0,
      "value": " do more and worry less"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.admin-features-title": [
    {
      "type": 0,
      "value": "You also get more admin features"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.default.description.non-final": [
    {
      "type": 1,
      "value": "requesterFullName"
    },
    {
      "type": 0,
      "value": " has requested to try features on the Confluence Premium plan."
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.default.no-name.description.non-final": [
    {
      "type": 0,
      "value": "Someone on your team has requested to try features on the Confluence Premium plan."
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.default.no-name.subject.non-final": [
    {
      "type": 0,
      "value": "Approval required: Someone in your team wants to try new features"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.default.no-name.title.non-final": [
    {
      "type": 0,
      "value": "Unlock more insights, clarity, and speed for your team"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.default.subject.non-final": [
    {
      "type": 0,
      "value": "Approval required: "
    },
    {
      "type": 1,
      "value": "requesterFullName"
    },
    {
      "type": 0,
      "value": " wants to try new features"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.default.title.non-final": [
    {
      "type": 0,
      "value": "Unlock more insights, clarity, and speed for "
    },
    {
      "type": 1,
      "value": "requesterFullName"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.explore-all-features": [
    {
      "type": 0,
      "value": "Explore all features →"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.get-started-button": [
    {
      "type": 0,
      "value": "Get Started"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.img.alt.non-final": [
    {
      "type": 0,
      "value": "Confluence logo"
    }
  ],
  "growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.test-message.email.body.non-final": [
    {
      "type": 0,
      "value": "Grant access on a free, "
    },
    {
      "type": 1,
      "value": "trialLengthDays"
    },
    {
      "type": 0,
      "value": "-day trial. Cancel anytime. We'll remind you before your trial ends."
    }
  ],
  "growth-luna.jira-recommend-retrial.banner.cta.permissions": [
    {
      "type": 0,
      "value": "Set up permissions"
    }
  ],
  "growth-luna.jira-recommend-retrial.banner.cta.plans": [
    {
      "type": 0,
      "value": "Create a plan"
    }
  ],
  "growth-luna.jira-recommend-retrial.banner.cta.rovo": [
    {
      "type": 0,
      "value": "Try Rovo AI"
    }
  ],
  "growth-luna.jira-recommend-retrial.banner.title.permissions": [
    {
      "type": 0,
      "value": "Keep work secure"
    }
  ],
  "growth-luna.jira-recommend-retrial.banner.title.plans": [
    {
      "type": 0,
      "value": "See all your timelines in one plan"
    }
  ],
  "growth-luna.jira-recommend-retrial.banner.title.rovo": [
    {
      "type": 0,
      "value": "Speed up your work"
    }
  ],
  "growth-luna.jira-recommend-retrial.permissions.allow-customer-submissions": [
    {
      "type": 0,
      "value": "Allow customers to submit bugs and requests"
    }
  ],
  "growth-luna.jira-recommend-retrial.permissions.assign-roles": [
    {
      "type": 0,
      "value": "Assign roles for groups, teams, or individuals"
    }
  ],
  "growth-luna.jira-recommend-retrial.permissions.set-custom-permissions": [
    {
      "type": 0,
      "value": "Set custom permissions for each role"
    }
  ],
  "growth-luna.jira-recommend-retrial.placement.suggested-feature.permissions": [
    {
      "type": 0,
      "value": "Keep work secure and organized"
    }
  ],
  "growth-luna.jira-recommend-retrial.placement.suggested-feature.plans": [
    {
      "type": 0,
      "value": "See all your timelines in one plan"
    }
  ],
  "growth-luna.jira-recommend-retrial.placement.suggested-feature.rovo": [
    {
      "type": 0,
      "value": "Speed up your work with AI"
    }
  ],
  "growth-luna.jira-recommend-retrial.plans.break-into-steps": [
    {
      "type": 0,
      "value": "Break plans into achievable steps with AI"
    }
  ],
  "growth-luna.jira-recommend-retrial.plans.customize-view": [
    {
      "type": 0,
      "value": "Customize your view to suit you"
    }
  ],
  "growth-luna.jira-recommend-retrial.plans.team-progress": [
    {
      "type": 0,
      "value": "See every team's progress in one place"
    }
  ],
  "growth-luna.jira-recommend-retrial.rovo.get-quick-answers-and-smart-suggestions": [
    {
      "type": 0,
      "value": "Get quick answers and smart suggestions"
    }
  ],
  "growth-luna.jira-recommend-retrial.rovo.instantly-summarize-work-items-and-updates": [
    {
      "type": 0,
      "value": "Instantly summarize work items and updates"
    }
  ],
  "growth-luna.jira-recommend-retrial.rovo.turn-big-projects-into-easy-tasks": [
    {
      "type": 0,
      "value": "Instantly turn big projects into easy tasks"
    }
  ],
  "jira-recommend-retrial.placement.body.has-payment": [
    {
      "type": 0,
      "value": "Enjoy "
    },
    {
      "type": 1,
      "value": "trialLength"
    },
    {
      "type": 0,
      "value": " days to try "
    },
    {
      "type": 1,
      "value": "suggestedFeature"
    },
    {
      "type": 0,
      "value": " with another free trial of "
    },
    {
      "options": {
        "other": {
          "value": [
            {
              "type": 0,
              "value": "Premium"
            }
          ]
        },
        "premium": {
          "value": [
            {
              "type": 0,
              "value": "Premium"
            }
          ]
        },
        "standard": {
          "value": [
            {
              "type": 0,
              "value": "Standard"
            }
          ]
        }
      },
      "type": 5,
      "value": "edition"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "post-office.ep-migration-inapp-715.body": [
    {
      "type": 0,
      "value": "Get Confluence Premium to ship projects faster with advanced admin controls and analytics."
    }
  ],
  "post-office.ep-migration-inapp-715.change-plans-button": [
    {
      "type": 0,
      "value": "Change plans"
    }
  ],
  "post-office.ep-migration-inapp-715.image-alt": [
    {
      "type": 0,
      "value": "Confluence Premium illustration"
    }
  ],
  "post-office.ep-migration-inapp-715.not-now-button": [
    {
      "type": 0,
      "value": "Not now"
    }
  ],
  "post-office.ep-migration-inapp-715.title": [
    {
      "type": 0,
      "value": "Grow more agile"
    }
  ],
  "post-office.jira-exp-banner.main-heading.no-translate": [
    {
      "type": 0,
      "value": "Welcome to Placements v2"
    }
  ],
  "post-office.jira-standard-automation-limit-awareness-banner.close": [
    {
      "type": 0,
      "value": "Close"
    }
  ],
  "post-office.jira-standard-automation-limit-awareness-banner.message": [
    {
      "type": 0,
      "value": "You're nearing or at your monthly automation run limit. Automations will fail to run this month if you hit the limit."
    }
  ]
}